import {Range} from '~/common/FabricInvitation/components/Range/Range';
import {useImageSize} from '~/common/FabricInvitation/EventCreateDesign/components/PhotoEditor/common/useImageSize';
import {useImageSizeLimits} from '~/common/FabricInvitation/EventCreateDesign/components/PhotoEditor/common/useImageSizeLimits';
import {
  MAX_IMAGE_SIZE,
  MIN_IMAGE_SIZE,
} from '~/common/FabricInvitation/EventCreateDesign/components/PhotoEditor/constants/imageSizeLimits';
import {Typography} from '~library/atoms/Typography';

export const SizeControl = ({canvas, processing}) => {
  const {scaleValue, setImageScale} = useImageSize();

  useImageSizeLimits(canvas, {min: MIN_IMAGE_SIZE, max: MAX_IMAGE_SIZE});

  return (
    <div className="uyo-control-slider-container">
      <Typography variant="list1" className="uyo-control-slider-label">
        Size
      </Typography>
      <div className="uyo-control-slider">
        <Range
          min={0.1}
          max={2}
          step={0.1}
          value={scaleValue}
          onChange={setImageScale}
          onLocalChange={setImageScale}
          hasControls
          hiddenInput
          dataQaId="size-slider"
          disabled={processing}
        />
      </div>
    </div>
  );
};
